import { useEffect, useState } from "react";
import { Loader2, CalendarCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { saveHistoryEntry } from "@/lib/bank";
import { mockTitle } from "@/data/mocks";

export const StudyPlan = ({ entry }) => {
  const [plan, setPlan] = useState(entry.plan || "");
  const [st, setSt] = useState({});
  const run = async () => {
    setSt({ loading: true });
    try {
      const { data } = await api.post("/ai/study-plan", { title: mockTitle(entry), overall: entry.overall, skills: entry.skills, parts: entry.parts });
      setPlan(data.plan); setSt({});
      saveHistoryEntry({ ...entry, plan: data.plan });
      if (localStorage.getItem("lexv_token")) api.post("/history", { entry_id: entry.id, payload: { ...entry, plan: data.plan } }).catch(() => {});
    } catch (e) { setSt({ error: errMsg(e) }); }
  };
  useEffect(() => { if (!entry.plan) run(); }, [entry.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div data-testid="study-plan" className="mt-6 rounded-xl bg-white p-6 shadow-xl">
      <div className="flex items-center gap-2"><CalendarCheck className="h-5 w-5 text-indigo-600" /><h2 className="font-display text-xl font-bold text-slate-900">Your 7-day study plan</h2>
        <span className="ml-auto font-mono text-[10px] uppercase tracking-widest text-slate-400">Claude</span></div>
      {st.loading && <p className="mt-3 inline-flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Writing a plan from your scores…</p>}
      {plan && !st.loading && <p data-testid="study-plan-text" className="mt-3 whitespace-pre-wrap text-sm leading-relaxed text-slate-700">{plan.replace(/\*\*|#+ /g, "")}</p>}
      {st.error && <p data-testid="study-plan-error" className="mt-3 text-sm text-rose-600">{st.error}</p>}
      {!st.loading && <button data-testid="study-plan-btn" onClick={run} className="mt-4 text-xs font-semibold text-indigo-600 underline">{plan ? "Regenerate plan" : "Generate plan"}</button>}
    </div>
  );
};
